import { createStyles, withStyles, WithStyles } from "@mui/styles";
import classNames from "classnames";
import * as React from "react";

const style = createStyles({
    filterToolbarFlexLine: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
});

interface IProps {
    className?: string;
}

type Props = IProps & WithStyles<typeof style>;

const MuiFilterLineComponent: React.FunctionComponent<Props> = (props) => {

    const { className, classes, children } = props;

    const cardClasses = classNames({
        [classes.filterToolbarFlexLine]: true,
        [className]: className !== undefined
    });

    return <div className={cardClasses}>{children}</div>;

};

export default withStyles(style)(MuiFilterLineComponent);
